









































































































import { Component, Vue, Prop } from "vue-property-decorator"
import { mapGetters } from "vuex"
import ReportMarginVue from "./ReportMargin.vue"

@Component({
    ...mapGetters(["accountBook"]),
    components: {
        "report-margin": ReportMarginVue
    }
})
export default class GenPrint extends Vue {
    @Prop({ type: [Array, Object] })
    dataList!: Subsidiary[];

    @Prop({ type: String })
    period!: string;

    @Prop({ type: Object })
    subject!: Subject.Subject;

    @Prop({ type: Array })
    subjectList!: Subject.Subject[];

    @Prop({ type: Boolean, default: false })
    noSelect!: boolean;

    @Prop({ type: String })
	fontSize!: string;

    subjectVal: Subject.Subject = this.subject;

    changeSubject(val: Subject.Subject) {
        this.$emit("update:subject", val);
        this.$emit("change", val);
    }
}
